module.exports = __webpack_public_path__ + "img/541-15-flat.53778a1c.jpg";